import usersTab from './usersTab';
import userTab from './userTab';
import userGroupTabs from '../groups/layout/userGroupTabs';
import userHistoryTab from './userHistoryTab';

export default [
  userHistoryTab,
  usersTab,
  userTab,
  ...userGroupTabs,
];
